import { render } from "./modal.vue?vue&type=template&id=1013cfbc"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import "./modal.vue?vue&type=style&index=0&id=1013cfbc&lang=css"
script.render = render

export default script